module.exports = __webpack_public_path__ + "img/jbt3411_98_1999_.prt.15cdfa4c.jpg";